/* eslint-disable import/prefer-default-export */

import { IAppConfig } from '../../../types/appConfig'
import { ActionProps } from './props'

export function setReduxAppConfig(appConfig: IAppConfig): ActionProps {
  return {
    type: 'SET_APP_CONFIG',
    appConfig,
  }
}
